export default "__VITE_ASSET__CE326aV9__"